import AddOn from '../entities/addOn';
import StorageAddOnModalPresenter from '../new_arch/modules/workspaces/modals/AddOnsModal/presenter/StorageAddOnModalPresenter';
import MembersAddOnModalPresenter from '../new_arch/modules/workspaces/modals/AddOnsModal/presenter/MembersAddOnModalPresenter';

export default class AddOnModalPresenterTypeFactory {
	static for( addOnModalPresenter ) {
		switch ( addOnModalPresenter.selectedAddOnType ) {
		case AddOn.storageType:
			return new StorageAddOnModalPresenter( addOnModalPresenter );
		case AddOn.membersType:
			return new MembersAddOnModalPresenter( addOnModalPresenter );
		default:
			throw Error( 'Invalid addOn type' );
		}
	}
}
